import React, { Component } from 'react';
import styles from '../styles.scss';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { getToken } from 'actions/auth/userToken';
import { withRouter } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import { Link } from 'react-router-dom';
import { openCustomModal } from 'actions/modals';
import { validate } from 'reducers/form/validate';
import classnames from 'classnames';
import bgImg from 'assets/images/signup-background.jpg';
import TextField from 'components/util/textField';
import logo from 'assets/images/logo-white.svg';

class SignIn extends Component {
  constructor() {
    super();
    this.state = {};
  }

  signIn = async ({ email, password }) => {
    if (email && password) {
      await getToken({ data: { email, password } });
      this.props.history.push('/');
    }
  };

  render() {
    return (
      <div
        className={styles.wrapper}
        style={{ backgroundImage: `url('${bgImg}')` }}>
        <div className={styles.inner}>
          <div className={styles.header}>
            <img src={logo} className={styles.logo} alt="logo" />
            <div className={styles.subtext}>Translate</div>
          </div>
          <div className={styles.container}>
            <div className={styles.title}>Welcome back!</div>
            <form
              onSubmit={this.props.handleSubmit(this.signIn)}
              noValidate={true}>
              <div>
                <div className={styles.inputWrapper}>
                  <Field
                    id="email"
                    component={TextField}
                    placeholder="Email"
                    name="email"
                    type="email"
                    icon="envelope"
                  />
                </div>
                <div className={styles.inputWrapper}>
                  <Field
                    id="password"
                    component={TextField}
                    placeholder="Password"
                    name="password"
                    type="password"
                    icon="lock"
                  />
                </div>
                <div className={styles.textCenter}>
                  <RaisedButton
                    type="submit"
                    label="Log In"
                    fullWidth
                    primary
                    className={styles.marginTopMd}
                  />
                </div>
                <div className={styles.textCenter}>
                  <div className={classnames(styles.bottomLink)}>
                    New user? <Link to="/sign-up">Sign Up</Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const validations = {
  required: {
    fields: ['email', 'password']
  }
};

SignIn = reduxForm({
  form: 'SignIn',
  validate: values => {
    return validate(values, validations);
  }
})(SignIn);

function mapStateToProps(state) {
  return {
    currentUserId: state.sessionSettings.currentUserId
  };
}

SignIn = withRouter(SignIn);

export default connect(
  mapStateToProps,
  { openCustomModal }
)(SignIn);



// WEBPACK FOOTER //
// ./src/components/auth/signIn/index.js